// The Help articles' bodies, keyed by article id (help/articles.ts is the table of contents).
// One file per article, named after its id: plain JSX with h2s carrying the section ids that the
// field-help topics link to (tests/unit/help-content.test.ts checks every listed section is there),
// paragraphs, lists and small tables. Links use <HelpLink> (another article) and <ScreenLink> (a
// screen), from ./parts.
import type { ComponentType } from "preact";
import type { ArticleId } from "../articles";
import { AddingACustomer } from "./adding-a-customer";
import { Assistant } from "./assistant";
import { AssistantApprovals } from "./assistant-approvals";
import { AuditLog } from "./audit-log";
import { AwsCosts } from "./aws-costs";
import { ClaudeCodeAndCodex } from "./claude-code-and-codex";
import { ClosingAMonth } from "./closing-a-month";
import { Glossary } from "./glossary";
import { Installations } from "./installations";
import { Installer } from "./installer";
import { ModelPrices } from "./model-prices";
import { PricingAndMarkup } from "./pricing-and-markup";
import { QuotasAndNotifications } from "./quotas-and-notifications";
import { RatePlans } from "./rate-plans";
import { Reconciliation } from "./reconciliation";
import { RevenueAndMargin } from "./revenue-and-margin";
import { SigningInAndRoles } from "./signing-in-and-roles";
import { TrialsAndCredits } from "./trials-and-credits";
import { UsageAdjustments } from "./usage-adjustments";
import { UsersTeamsAndSignIn } from "./users-teams-and-sign-in";
import { WhatNexusDoes } from "./what-nexus-does";

export const ARTICLE_CONTENT: Readonly<Record<ArticleId, ComponentType>> = {
  "what-nexus-does": WhatNexusDoes,
  "signing-in-and-roles": SigningInAndRoles,
  glossary: Glossary,
  "adding-a-customer": AddingACustomer,
  "users-teams-and-sign-in": UsersTeamsAndSignIn,
  installations: Installations,
  "quotas-and-notifications": QuotasAndNotifications,
  "pricing-and-markup": PricingAndMarkup,
  "model-prices": ModelPrices,
  "rate-plans": RatePlans,
  "trials-and-credits": TrialsAndCredits,
  "usage-adjustments": UsageAdjustments,
  "closing-a-month": ClosingAMonth,
  "revenue-and-margin": RevenueAndMargin,
  "aws-costs": AwsCosts,
  reconciliation: Reconciliation,
  installer: Installer,
  assistant: Assistant,
  "assistant-approvals": AssistantApprovals,
  "audit-log": AuditLog,
  "claude-code-and-codex": ClaudeCodeAndCodex,
};
